import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ResetPasswordComponent } from './reset-password.component';
import { UserFacade } from '../account/store/facades/user-facade';
import { CirrusButtonModule } from '../shared/cirrus/button/cirrus-button.module';
import { CirrusFieldWrapperModule } from '../shared/cirrus/field-wrapper/cirrus-field-wrapper.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    CirrusButtonModule,
    CirrusFieldWrapperModule
  ],
  declarations: [ResetPasswordComponent],
  providers: [UserFacade]
})
export class ResetPasswordModule {}
